import React from "react";
import { compose, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import { grantPublicationAccess } from "./_actions";

class GrantPublicationAccessModal extends React.Component {
    _validate = (values) => {
        const errors = {};

        errors.inviteeEmail = FormUtils.validators.required(values.inviteeEmail);
        errors.inviteeEmail = errors.inviteeEmail || FormUtils.validators.email(values.inviteeEmail);
        errors.inviteeEmail = errors.inviteeEmail || FormUtils.validators.maxLength(255)(values.inviteeEmail);

        return errors;
    };

    _save = (values) => {
        values.role = "PublicationAgent";
        this.props.grantPublicationAccess(values);
    };

    render() {
        const { viewModel } = this.props;
        const isAResend = viewModel.inviteeEmail ? true : false;

        return (
            <Form initialValues={viewModel} validate={this._validate} onSubmit={this._save}>
                {({ values, handleSubmit, submitSucceeded }) => {
                    return (
                        <Modal title="Grant publication access" instructions="Add a new user to act as your agent for publications that are published to you for this farm.">
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="id" type="hidden" component="input" />
                                                <Field name="inviteeEmail" label="Email" placeholder="Email address" disabled={isAResend} required type="text" component={InputPack} />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button Button--primary" disabled={submitSucceeded}>
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}

export default compose(withActions({ grantPublicationAccess }))(GrantPublicationAccessModal);
